// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"70e08fe9","732":"8a23d2a4"}[chunkId] + ".chunk.js";
};